import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { history, fetchWrapper } from '_helpers';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// create slice

const name = 'games';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState,  extraReducers });

// exports

export const gamesActions = { ...slice.actions, ...extraActions };
export const gamesReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        // initialize state from local storage to enable user to stay logged in
        user: JSON.parse(localStorage.getItem('user')),
        error: null
    }
}


function createExtraActions() {
    const baseUrl = `https://api.webtracktechnologies.com.au:8002`;
   //const registerUrl = `${process.env.REACT_APP_API_URL}/frontend/auth/register/step-1`;

    return {
        saveRewards:saveRewards(),
        getgiftboxlimit:getgiftboxlimit(),
        savePoints:savePoints(),
    };    

    function saveRewards() {
        return createAsyncThunk(
            `${name}/games`,
            async ({student_id, amount, type , boxtype}) => await fetchWrapper.post(`${baseUrl}/games/saverewards`,{student_id,amount,type,boxtype})
        );
    }

    function getgiftboxlimit() {
        return createAsyncThunk(
            `${name}/games`,
             async ({student_id}) => await fetchWrapper.get(`${baseUrl}/games/giftboxlimit/`+student_id)
        );
    }

    function savePoints() {
        return createAsyncThunk(
            `${name}/games`,
            async ({students}) => await fetchWrapper.post(`${baseUrl}/games/savepoints`,{students})
        );
    }

}

function createExtraReducers() {
    return {
        ...saveRewards(),
        ...getgiftboxlimit(),
        ...savePoints(),
    };

    function saveRewards() {
        var { pending, fulfilled, rejected } = extraActions.saveRewards;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const games = action.payload;
             
                state.games = games;

            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

     function getgiftboxlimit() {
        var { pending, fulfilled, rejected } = extraActions.getgiftboxlimit;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const games = action.payload;
             
                state.games.limit = games;

            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

    function savePoints() {
        var { pending, fulfilled, rejected } = extraActions.savePoints;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const games = action.payload;
             
                state.games = games;

            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

 
}
